export const statusOption = [
  "Send for screening",
  "Send welcome email",
  "Edit tagged recruiter",
  "Schedule",
  "Reject",
  "Dropout",
  "On Hold",
  "Edit",
  "Offered",
  "Hired",
];

export const jobFuntion = [
  "Loan Recovery",
  "Customer Care",
  "Accounting",
  "Administrative",
  "Arts and Design",
  "Business Development",
  "Community and Social Services",
  "Consulting",
  "Education",
  "Engineering",
  "Entrepreneurship",
  "Finance",
  "Healthcare Services",
  "Human Resources",
  "Information Technology",
  "Legal",
  "Marketing",
  "Media and Communication",
  "Military and Protective Services",
  "Operations",
  "Product Management",
  "Program and Project Management",
  "Purchasing",
  "Quality Assurance",
  "Real Estate",
  "Research",
  "Sales",
  "Support",
];

export const JobProfile = [
  "Loan Recovery",
  "Customer Care",
  "Accounting",
  "Administrative",
  "Arts and Design",
  "Business Development",
  "Community and Social Services",
  "Consulting",
  "Education",
  "Engineering",
  "Entrepreneurship",
  "Finance",
  "Healthcare Services",
  "Human Resources",
  "Information Technology",
  "Legal",
  "Marketing",
  "Media and Communication",
  "Military and Protective Services",
  "Operations",
  "Product Management",
  "Program and Project Management",
  "Purchasing",
  "Quality Assurance",
  "Real Estate",
  "Research",
  "Sales",
  "Support",
];
export const team = [
  "Loan Recovery",
  "Customer Care",
  "Accounting",
  "Administrative",
  "Arts and Design",
  "Business Development",
  "Community and Social Services",
  "Consulting",
  "Education",
  "Engineering",
  "Entrepreneurship",
  "Finance",
  "Healthcare Services",
  "Human Resources",
  "Information Technology",
  "Legal",
  "Marketing",
  "Media and Communication",
  "Military and Protective Services",
  "Operations",
  "Product Management",
  "Program and Project Management",
  "Purchasing",
  "Quality Assurance",
  "Real Estate",
  "Research",
  "Sales",
  "Support",
];
export const employmentType = [
  "Intern",
  "Contract",
  "Full Time",
  "Part Time",
  "Probation",
  "Permatent",
  "Commission",
  "Freelancer",
  "Agency Resource",
  "Temporary",
  "Consultant",
  "Apprentice",
];

export const sourceType = [
  "Agency",
  "Enternal Recruiter",
  "Internal Recruiter",
  "Direct",
  "Social",
];
export const workplaceType = ["Remote", "Onsite", "Hybid"];


export const Categories = [
  "Password Issue",
  "License Issue",
  "Email Issue ",
  "VPN Configuration",
  "Calls Not Recording",
  "Agent's Access Deactivation",
  "Agent's Access Reactivation",
  "Account reference locked out",
  "AUUID Creation",
  "Access Creation",
];

export const Salutation = ["Mr", "Mrs", "Miss", "Sir", "Dr"];
export const Gender = ["Male", "Female"];
export const experienceLevel = [
  "Entry - level(0 – 2 years of experience)",
  "Mid - level(3 - 5 years of experience)",
  "Senior - level(6 – 9 years of experience)",
  "Management - level(10+ years of experience)",
];
export const education = [
  "SSCE",
  "OND",
  "NCE",
  "HND",
  "BSC",
  "PGD",
  "MSC",
  "PHD",
];
export const editRecruiter = [
  "Benson Onoja",
  "Adeola Adeyemi",
  "Nyore",
  "Chiamaka Ugumba",
  "Favour Amaka",
];
export const screeningOption = [
  "SCREENING",
];
// export const screeningOption = [
//   "SCREENING",
//   "EVALUATION",
//   "OFFERED",
//   "INTERVIEW",
//   "HIRED",
//   "DROPOUT",
//   "DRAFT",
// ];
export const interviewOption = [
  "INTERVIEW",
];
export const updateOption = [
  "HIRED",
  "DROPOUT",
  "DRAFT",
];
export const dropoutOption = [
  "DROPOUT",
  // "DRAFT",
];
export const tranningOption = [
  "PENDING",
];
export const hireOption = [
  "HIRED",
];
export const evaluatingOption = [
  // "APPLIED",
  "EVALUATION",
];
export const evaluatingOptionInterview = [
  "INTERVIEW",
];

export const interviewStage = [
  // "PENDING",
  "INTERVIEW",
  // "EVALUATION",
  // "INTERVIEW",
  // "DROPOUT"
];
export const OfferStatus = [
  "ACCEPTED",
  "DECLINED",
];
export const UpdateTraning = [
  "COMPLETED",
];

export const headerTitles = [
  "",
  "First Name",
  "Last Name",
  "Email",
  "Phone Number",
  "Role",
  "isActive",
];
export const TaskTitles = [
  "",
  "Edit",
  "Title",
  "Name",
  "Date Applied",
  "Application Status",
  "Email",
  "Phone Number",
  "Location",
  "Notice Period",

];




